import { RouteRecordRaw } from "vue-router";

const sidebarName = "SidebarIssueMonitoring";

export const issueMonitoringRoutes: RouteRecordRaw[] = [
  {
    path: "/issue-monitoring",
    component: () => import("@/views/common/Home.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/samplingpoints",
    component: () => import("@/views/issueMonitoring/SamplingPointList.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/samplingpoints/gallery/",
    component: () => import("@/views/issueMonitoring/GalleryEstimation.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/stations/new",
    component: () => import("@/views/issueMonitoring/NewStations.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/upload",
    component: () => import("@/views/support/UploadData.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/trainingdata",
    component: () => import("@/views/admin/TrainingDataForm.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/downloadTrainingData",
    component: () => import("@/views/admin/downloadTrainingData.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },

  {
    path: "/issue-monitoring/samplingpoints/classificationImage",
    component: () => import("@/views/issueMonitoring/ClassificationImage.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },

  {
    path: "/issue-monitoring/samplingpoints/classificationImage/imagelabel/",
    component: () => import("@/views/issueMonitoring/ImageLabel.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/samplingpoints/samplingPointConfig",
    component: () => import("@/views/issueMonitoring/SamplingPointConfig.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
  {
    path: "/issue-monitoring/samplingpoints/FQConfig",
    component: () => import("@/views/issueMonitoring/SamplingPointFQConfig.view.vue"),
    meta: {
      layout: "LayoutDefault",
      sidebar: sidebarName,
    },
  },
];
